import { Button, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { Link } from '~components/ui/Link';
import { Page } from '~components/ui/Page';
import { PageContent } from '~components/ui/PageContent';

export function ScheduleNotFoundPage() {
  return (
    <Page title="404" pageName="schedule_404" analyticsDisableTracking={true}>
      <PageContent maxWidth="300px" textAlign="center">
        <Text fontWeight="semibold" color="gray.600">
          {t('unauthorisedScheduleErr')}
        </Text>

        <Text marginTop="8" fontSize="sm">
          {t('unauthorisedScheduleErrMsg')}{' '}
          <Button as={Link} variant="link" size="sm" colorScheme="blue" to="../">
            {t('unauthorisedScheduleErrMsg1')}
          </Button>
        </Text>
      </PageContent>
    </Page>
  );
}
